import styled from 'styled-components';

export const DiscountsSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 24px 61px 36px;
  margin-bottom: 16px;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
    padding: 24px 20px 36px;
  }
  @media (max-width: 470px) {
    grid-template-columns: 1fr;
    padding: 20px 16px;
    gap: 16px;
  }
`;

export const DiscountsSummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

export const DiscountsSummaryValue = styled.div`
  font-size: 42px;
  font-weight: 275;
  color: #2f3d48;
  line-height: 1.5;
`;

export const DiscountsSummaryInfo = styled.div`
  position: relative;
  top: -8px;
`;

export const DiscountsSummaryLabel = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: #b3b9c2;
  line-height: 1.5;
`;

export const DiscountsSummaryDelta = styled.div`
  font-size: 10px;
  font-weight: 700;
  color: #17c981;
  line-height: 1.5;
`;

export const StatusBadge = styled.span`
  font-size: 14px;
  font-weight: 800;
  &.active {
    color: #17c981;
  }
  &.archived {
    color: #b3b9c2;
  }
`;
